module.exports = __webpack_public_path__ + "static/media/content-su-kien-2.c9b86471.png";